import { Component, OnInit, OnDestroy } from "@angular/core";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { filter } from "rxjs";
import { ConfirmationModalComponent } from "../shared/components/confirmation-modal/confirmation-modal.component";
import { environment } from "../environments/environment";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet, ConfirmationModalComponent],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.css",
})
export class AppComponent implements OnInit, OnDestroy {
  showNavbar = true;
  private sseStream: EventSource | null = null;

  constructor(private router: Router) {
    // Detect route changes
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Hide navbar/footer for all routes starting with "/admin"
        this.showNavbar = !event.urlAfterRedirects.startsWith("/admin");
      });
  }

  ngOnInit(): void {
    if (typeof window === 'undefined') return;

    const sseUrl = `${environment.baseUrl}/dating/settings/sse`;
    this.sseStream = new EventSource(sseUrl);

    this.sseStream.onmessage = (event) => {
      try {
        const settings = JSON.parse(event.data);
        if (settings && settings.system_outage) {
          const userStr = localStorage.getItem('user');
          if (userStr) {
            const user = JSON.parse(userStr);
            const userRole = user.role || user.data?.role;
            const isAuthorized = userRole === 'admin' || userRole === 'super_admin';

            if (!isAuthorized) {
              console.warn('System outage active: Force logging out normal user');
              localStorage.clear();
              sessionStorage.clear();
              this.router.navigate(['/auth/login']);
            }
          }
        }
      } catch (err) {
        console.error('Failed to parse settings SSE in AppComponent:', err);
      }
    };

    this.sseStream.onerror = (err) => {
      console.warn('Settings SSE subscription warning in Angular AppComponent:', err);
    };
  }

  ngOnDestroy(): void {
    if (this.sseStream) {
      this.sseStream.close();
      this.sseStream = null;
    }
  }
}
